import makeRequest from '@jg/http-client';
import { Auth } from '@jg/auth';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { isDataURL } from '@jg/image-editor';
import { httpActions, apiActions } from '..';
import { REQUEST, ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import uploadImage from '../../utils/uploadImage';
import { IAppState } from '../../types/state.d';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';
import { getTeamGuid } from '../../selectors/apiSelectors';
import { IStoryFormProps } from '../../containers/Story/Story.d';
import { saveStoryData } from '../actionCreators/appActions';

const updateStory = (storyData: IStoryFormProps) => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  const updateStoryResourceName = REQUEST.UPDATE_STORY_DATA;
  const uploadImageResourceName = REQUEST.UPLOAD_IMAGE;
  try {
    let heroImage;
    await auth.refreshAccessTokenIfExpired();
    const state = getState();
    const teamGuid = getTeamGuid(state);

    // TODO Move out hero image from update story thunk into its own thunk
    if (storyData.heroImage && isDataURL(storyData.heroImage)) {
      dispatch(httpActions.httpRequestMade(uploadImageResourceName));
      heroImage = await uploadImage(storyData.heroImage);
      dispatch(httpActions.httpRequestSuccess(uploadImageResourceName));
      dispatch(apiActions.saveUploadedCoverPhoto(heroImage));
    } else if (storyData.heroImage) {
      heroImage = storyData.heroImage;
    }
    dispatch(httpActions.httpRequestMade(updateStoryResourceName));
    const { default: mapStory } = await import('../../utils/mapStory');
    const story = await mapStory(storyData.story);
    const body = JSON.stringify({
      story,
      coverPhotoImageId: heroImage || null,
    });

    const response = await makeRequest(
      `${config.pagesAPI}v1/teams/${teamGuid}/details`,
      {
        method: 'PUT',
        timeoutInMs: config.imageUploadTimeoutInMs,
        body,
        extraHeaders: generateAuthHeaders(auth),
      },
    );

    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(ERROR_MESSAGES.UPDATE_STORY);
    }
    dispatch(httpActions.httpRequestSuccess(updateStoryResourceName));
    dispatch(saveStoryData(storyData));
  } catch (error) {
    dispatch(httpActions.httpRequestError(updateStoryResourceName, error));
    throw error;
  }
};

export default updateStory;
